import React from 'react';
import { bool, func, object, string } from 'prop-types';

import { isEmpty } from 'lodash';

import MaterialTable from 'material-table';

import EsmsDialog from '../../components/EsmsDialog';

import classes from './PendingActionsModal.module.css';

const PendingActionsModal = ({
    actionData,
    onConfirm,
    onClose,
    open,
    title,
    ...props
}) => {

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    if (isEmpty(actionData)) return null;

    return (
        <EsmsDialog
            className={classes.PendingActionsModal}
            confirmText="Continue"
            onCancel={handleClose}
            onClose={handleClose}
            onConfirm={handleConfirm}
            open={open}
            title={title}
        >
            <div className={classes.modalWrapper}>
                <div className={classes.actionContainer}>
                    <p>{actionData.actionableData.title || 'To be created'}</p>
                    <div className={classes.PendingActionsTable}>
                        <MaterialTable
                            options={{
                                paging:        false,
                                showTitle:     false,
                                search:        false,
                                selection:     false,
                                toolbar:       false,
                                headerStyle:   { position: 'sticky', top: 0 },
                                maxBodyHeight: '28rem'
                            }}
                            columns={[
                                {
                                    title:       'Name',
                                    field:       'name',
                                    defaultSort: 'asc'
                                }
                            ]}
                            data={actionData.actionableData.data}
                        />
                    </div>
                </div>
                <div className={classes.actionContainer}>
                    <p>{actionData.nonActionableData.title || 'Will not be created'}</p>
                    <div className={classes.PendingActionsTable}>
                        <MaterialTable
                            options={{
                                paging:        false,
                                showTitle:     false,
                                search:        false,
                                selection:     false,
                                toolbar:       false,
                                headerStyle:   { position: 'sticky', top: 0 },
                                maxBodyHeight: '28rem'
                            }}
                            columns={[
                                {
                                    title:       'Name',
                                    field:       'name',
                                    defaultSort: 'asc'
                                },
                                {
                                    title: 'Reason',
                                    field: 'reason'
                                },
                                {
                                    title: 'Action',
                                    field: 'action'
                                }
                            ]}
                            data={actionData.nonActionableData.data}
                        />
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

PendingActionsModal.defaultProps = {
    actionData: {},
    onClose:    () => {},
    onConfirm:  () => {},
    open:       false,
    title:      'Pending Actions'
};

PendingActionsModal.propTypes = {
    actionData: object,
    onClose:    func,
    onConfirm:  func,
    open:       bool,
    title:      string
};

export default PendingActionsModal;
